import React, { useState } from "react";
import "../../assets/styles/order3.css";
import { motion } from "framer-motion";
import Vector2 from "../../assets/images/vect1.png";
import vect2 from "../../assets/images/vect2.png";
import vect3 from "../../assets/images/Vector3.png";

const Order3 = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    if (!email) {
      // alert("Please enter your email!");
      return;
    }

    const recipientEmail = "sales@commceed.com";
    const subject = "New Newsletter Subscription";
    const body = `Hello,\n\nPlease add ${email} to the newsletter subscription list.`;

    window.location.href = `mailto:${recipientEmail}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    setEmail("");
  };
  return (
    <div className="order3-container">
      {/* Top Section (White Background) */}
      <motion.div
        className="top-section"
        initial={{ opacity: 0, y: 50 }} // Start slightly below for smoother transition
        whileInView={{ opacity: 1, y: 0 }} // Slide to original position
        viewport={{ once: true }}
        transition={{ duration: 1.5, ease: "easeInOut" }} // Slower and smoother transition
      >
        <motion.img
          src={vect3}
          alt="Vector 3"
          className="vector3"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        />
        <motion.h1
          className="order3-heading"
          initial={{ opacity: 0, y: 20 }} // Start with opacity 0 and slightly below
          whileInView={{ opacity: 1, y: 0 }} // Fade in and slide to position
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          STAY CONNECTED, STAY AHEAD WITH commceed
        </motion.h1>
        <motion.p
          className="order3-paragraph"
          initial={{ opacity: 0, y: 20 }} // Start with opacity 0 and slightly below
          whileInView={{ opacity: 1, y: 0 }} // Fade in and slide to position
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          Reach us on
        </motion.p>
        <motion.div className="contact-info">
          <motion.p className="order3-paragraph">
            <span className="label">Email</span>{" "}
            <span className="value">: sales@commceed.com</span>
          </motion.p>
          <motion.p className="order3-paragraph">
            <span className="label">Office</span>{" "}
            <span className="value">: +61 3 8564 8530</span>
          </motion.p>
          <motion.p className="order3-paragraph">
            <span className="label">Sales</span>{" "}
            <span className="value">: +61 478 97 6061</span>
          </motion.p>
          <motion.p className="order3-paragraph">
            <span className="label">WhatsApp</span>{" "}
            <span className="value">: +61 478 97 6061</span>
          </motion.p>
        </motion.div>
      </motion.div>

      {/* Bottom Section (Black Background) */}
      <motion.div
        className="bottom-section"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      >
        {/* <motion.img 
          src={Vector2} 
          alt="Vector 1" 
          className="vector1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}  // Slide from the left
          transition={{ duration: 1.5, ease: "easeInOut" }}
        />
        <motion.img 
          src={vect2} 
          alt="Vector 2" 
          className="vector2"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}  // Slide from the right
          transition={{ duration: 1.5, ease: "easeInOut" }}
        /> */}

        <motion.div
          className="button-section"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          <input
            type="email"
            placeholder="Your Email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="subscribe-button" onClick={handleSubscribe}>
            SUBSCRIBE
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Order3;
